import release from '@/views/product/views/release/release';
export default release;